export default __webpack_public_path__ + "static/media/hour-glass_white.c51c8ce0.svg";